<template>
  <div class="domino-card">
    <div class="domino-player">
      <div class="domino-player-total">{{ $t("domino.PLAYER") }}</div>
      <div class="domino-player-card-container">
        <div class="domino-player-first-card" :class="{ 'flip-active': flipP1 }">
          <div ref="player-first-front-card" class="player-first-front-card"></div>
          <div ref="player-first-back-card" class="player-first-back-card"></div>
        </div>
        <div class="domino-player-sec-card" :class="{ 'flip-active': flipP2 }">
          <div ref="player-sec-front-card" class="player-sec-front-card"></div>
          <div ref="player-sec-back-card" class="player-sec-back-card"></div>
        </div>
      </div>
      <div class="domino-player-total">{{ startdrawing? drawPSum:playerSum }}</div>
    </div>
    <div class="domino-vs">VS</div>
    <div class="domino-banker">
      <div class="domino-banker-total">{{ $t("domino.BANKER") }}</div>
      <div class="domino-banker-card-container">
        <div class="domino-banker-first-card" :class="{ 'flip-active': flipB1 }">
          <div ref="banker-first-front-card" class="banker-first-front-card"></div>
          <div ref="banker-first-back-card" class="banker-first-back-card"></div>
        </div>
        <div class="domino-banker-sec-card" :class="{ 'flip-active': flipB2 }">
          <div ref="banker-sec-front-card" class="banker-sec-front-card"></div>
          <div ref="banker-sec-back-card" class="banker-sec-back-card"></div>
        </div>
      </div>
      <div class="domino-banker-total">{{ startdrawing? drawBSum:bankerSum }}</div>
    </div>
  </div>
</template>

<script>
import { Row, Col, Button } from "iview";
// import NewBetLot from "../../commons/NewBetLot";
import betLotMixin from "../../../mixins/bet-lot-mixin";
import EventBus from "../../../configs/event-bus";

export default {
  mixins: [betLotMixin],
  props: [
    "game",
    "winCellNo",
    "secondsString",
    "minutesString",
    "gameData",
    "showDrawingAnimation",
    "drawResult"
  ],
  components: {
    Row,
    Col,
    Button
  },
  data() {
    return {
      startdrawing: false,
      flipP1: false,
      flipP2: false,
      flipB1: false,
      flipB2: false,
      drawPSum: 0,
      drawBSum: 0,
      drawPSumP2: 0,
      drawBSumB2: 0
    };
  },
  watch: {
    showDrawingAnimation(newVal, oldVal) {
      let vm = this;
      if (newVal) {
        // console.log("Domino show drawing");
      }
    },
    drawResult(newVal, oldVal) {
      let vm = this;
      if (newVal) {
        vm.startdrawing = true;
        vm.flipP1 = true;
        vm.flipP2 = true;
        vm.flipB1 = true;
        vm.flipB2 = true;
        vm.drawPSum = 0;
        vm.drawBSum = 0;
        vm.drawPSumP2 = 0;
        vm.drawBSumB2 = 0;

        setTimeout(() => {
          vm.$refs[
            "player-first-front-card"
          ].style.backgroundImage = `url(${require(`../../../assets/images/domino/${this.drawResult.p1_result}.png`)})`;
          vm.$refs[
            "player-sec-front-card"
          ].style.backgroundImage = `url(${require(`../../../assets/images/domino/${this.drawResult.p2_result}.png`)})`;
          vm.$refs[
            "banker-first-front-card"
          ].style.backgroundImage = `url(${require(`../../../assets/images/domino/${this.drawResult.b1_result}.png`)})`;
          vm.$refs[
            "banker-sec-front-card"
          ].style.backgroundImage = `url(${require(`../../../assets/images/domino/${this.drawResult.b2_result}.png`)})`;

          vm.flipP1 = false;
          vm.drawPSum += parseInt(this.drawResult.p1_result.charAt(0));
          vm.drawPSum += parseInt(this.drawResult.p1_result.charAt(1));
          vm.drawPSum %= 10;
          this.showResult(vm.drawPSum); //get value when flip the card

          setTimeout(() => {
            vm.flipB1 = false;
            vm.drawBSum += parseInt(this.drawResult.b1_result.charAt(0));
            vm.drawBSum += parseInt(this.drawResult.b1_result.charAt(1));
            vm.drawBSum %= 10;
            this.showResult(vm.drawBSum);

            setTimeout(() => {
              vm.flipP2 = false;
              vm.drawPSum += parseInt(this.drawResult.p2_result.charAt(0));
              vm.drawPSum += parseInt(this.drawResult.p2_result.charAt(1));
              vm.drawPSum %= 10;

              //for get the value when flip the second card
              vm.drawPSumP2 += parseInt(this.drawResult.p2_result.charAt(0));
              vm.drawPSumP2 += parseInt(this.drawResult.p2_result.charAt(1));
              this.showResult(vm.drawPSumP2);

              setTimeout(() => {
                vm.flipB2 = false;
                vm.drawBSum += parseInt(this.drawResult.b2_result.charAt(0));
                vm.drawBSum += parseInt(this.drawResult.b2_result.charAt(1));
                vm.drawBSum %= 10;

                //for get the value when flip the second card
                vm.drawBSumB2 += parseInt(this.drawResult.b2_result.charAt(0));
                vm.drawBSumB2 += parseInt(this.drawResult.b2_result.charAt(1));
                this.showResult(vm.drawBSumB2);

                setTimeout(() => {
                  clearStakeRecord(vm.gameData.gID);
                  EventBus.$emit("update-session-storage");

                  this.animationEnd();

                  vm.startdrawing = false;
                }, 1000);
              }, 1000);
            }, 1000);
          }, 1000);
        }, 1000);
      }
    }
  },
  computed: {
    playerSum() {
      return this.drawResult.p_sum;
    },
    bankerSum() {
      return this.drawResult.b_sum;
    }
  },
  mounted() {
    this.$refs[
      "player-first-front-card"
    ].style.backgroundImage = `url(${require(`../../../assets/images/domino/${this.gameData.prev.p1_result}.png`)})`;
    this.$refs[
      "player-sec-front-card"
    ].style.backgroundImage = `url(${require(`../../../assets/images/domino/${this.gameData.prev.p2_result}.png`)})`;
    this.$refs[
      "banker-first-front-card"
    ].style.backgroundImage = `url(${require(`../../../assets/images/domino/${this.gameData.prev.b1_result}.png`)})`;
    this.$refs[
      "banker-sec-front-card"
    ].style.backgroundImage = `url(${require(`../../../assets/images/domino/${this.gameData.prev.b2_result}.png`)})`;
  },
  methods: {
    animationEnd() {
      this.$emit("on-animation-end");
    },
    showResult(result) {
      //pass to domino game show result function
      this.$emit("show-result", result);
    }
  }
};
</script>

<style lang="scss" scoped>
.domino-card {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 140px;
  width: 100%;
  // background: url("../../../assets/images/domino/red-bg.jpg");
  background: #182841;
  background: -moz-linear-gradient(top, #182841 0%, #0a1527 100%);
  background: -webkit-linear-gradient(top, #182841 0%, #0a1527 100%);
  background: linear-gradient(to bottom, #182841 0%, #0a1527 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#182841', endColorstr='#0a1527',GradientType=0 );
}

.domino-player {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 40%;
  height: 100%;
}
.domino-player-card-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

//player-first-card-flip
.domino-player-first-card {
  width: 50px;
  height: 80px;
  position: relative;
  text-align: center;
  transition: transform 0.6s;
  transform-style: preserve-3d;
}
.flip-active {
  transform: rotateY(180deg);
}
// .domino-player-first-card:hover {
//   transform: rotateY(180deg);
// }
.player-first-front-card {
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  // background-image: url("../../../assets/images/domino/66.png");
}
.player-first-front-card,
.player-first-back-card {
  position: absolute;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
}
.player-first-back-card {
  transform: rotateY(180deg);
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url("../../../assets/images/domino/back.png");
}

//player-sec-card-flip
.domino-player-sec-card {
  width: 50px;
  height: 80px;
  position: relative;
  text-align: center;
  transition: transform 0.6s;
  transform-style: preserve-3d;
}
// .domino-player-sec-card:hover {
//   transform: rotateY(180deg);
// }
.player-sec-front-card {
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  // background-image: url("../../../assets/images/domino/66.png");
}
.player-sec-front-card,
.player-sec-back-card {
  position: absolute;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
}
.player-sec-back-card {
  transform: rotateY(180deg);
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url("../../../assets/images/domino/back.png");
}

//banker-first-card-flip
.domino-banker-first-card {
  width: 50px;
  height: 80px;
  position: relative;
  text-align: center;
  transition: transform 0.6s;
  transform-style: preserve-3d;
}
// .domino-banker-first-card:hover {
//   transform: rotateY(180deg);
// }
.banker-first-front-card {
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  // background-image: url("../../../assets/images/domino/66.png");
}
.banker-first-front-card,
.banker-first-back-card {
  position: absolute;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
}
.banker-first-back-card {
  transform: rotateY(180deg);
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url("../../../assets/images/domino/back.png");
}

//banker-sec-card-flip
.domino-banker-sec-card {
  width: 50px;
  height: 80px;
  position: relative;
  text-align: center;
  transition: transform 0.6s;
  transform-style: preserve-3d;
}
// .domino-banker-sec-card:hover {
//   transform: rotateY(180deg);
// }
.banker-sec-front-card {
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  // background-image: url("../../../assets/images/domino/66.png");
}
.banker-sec-front-card,
.banker-sec-back-card {
  position: absolute;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
}
.banker-sec-back-card {
  transform: rotateY(180deg);
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url("../../../assets/images/domino/back.png");
}

.domino-player-total {
  font-size: 16px;
  font-weight: bold;
  color: $domino-trend-lot-color-1;
}
.domino-vs {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20%;
  height: 100%;
  font-size: 30px;
  font-weight: bold;
  color: white;
}
.domino-banker {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 40%;
  height: 100%;
}
.domino-banker-card-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.domino-banker-total {
  font-size: 16px;
  font-weight: bold;
  color: $domino-trend-lot-color-2;
}
.domino-card-container {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 100%;
  height: 94%;
  text-align: center;
  transition: transform 0.6s;
  transform-style: preserve-3d;
}

.card {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}
.card-back {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;

  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}
.flip-active {
  transform: rotateY(180deg);
}
.card,
.card-back {
  position: absolute;

  backface-visibility: hidden;
}
.card-back {
  //  backface-visibility: visible;
  background-color: white;
  transform: rotateY(180deg);
}

.count-up-sec {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 35px;
  width: 35px;
  border-radius: 50%;
  background-color: #858585;
  border: 1px solid transparent;
}
.count-up-third {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 25px;
  width: 25px;
  border-radius: 50%;
  border: 1px solid transparent;
  background-color: #2a2a2a;
}
.round-up {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  height: 31px;
  width: 31px;
  color: white;
  font-size: 12px;
  text-align: center;
}
.round-up svg {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  margin: -1px;
  top: 0;
  right: 0;
  width: 26px;
  height: 32px;
  transform: rotateZ(90deg) rotateZ(180deg);
}
.round-up svg circle {
  stroke-linecap: unset;
  stroke-width: 2px;
  stroke: #ff8a01;
  fill: none;
  r: 12;
  cx: 12.5;
  cy: 16.5;
}

.domino-card-betlot {
  flex: 1;
  margin: 0 2px;
}

.domino-card-betlot:first-of-type {
  margin-left: unset;
}

.domino-card-betlot:last-of-type {
  margin-right: unset;
}
</style>
